'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.company_index', {
        url: '/company_index/:stateName',
        template: '<company-index></company-index>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/company/index/company_index.route.js